import * as React from 'react';
import { Box, Card, CardContent, CardHeader, Chip, Grid } from '@material-ui/core';
import { CaseAttachment, DamagePartDto, DamagePartPhotoDto } from '../../../../interfaces/Case';
import CaseAttachmentCard from '../../../_shared/CaseAttachmentCard';
import { DistanceTypeCode } from '../utils/damagePartPhotos.utils';

export interface DamagePartCardProps {
  part: DamagePartDto;
  attachments: Record<number, CaseAttachment>;
}

const distanceTypeBadge = (photo: DamagePartPhotoDto) => (
  <Chip
    size="small"
    color={photo.distanceType?.code === DistanceTypeCode.FAR ? 'primary' : 'secondary'}
    label={photo.distanceType?.displayName}
  />
);

const DamagePartCard: React.FC<DamagePartCardProps> = ({ part, attachments }) => (
  <Card elevation={0}>
    <Box bgcolor="grey.100">
      <CardHeader
        title={part.partName}
        subheader={part.damageType?.description}
        action={
          part.damageLevel ? <Chip size="small" label={part.damageLevel.displayName} /> : null
        }
      />
      <CardContent>
        <Grid container spacing={2}>
          {part.photos.map((photo) => (
            <Grid item container xs={12} md={6} key={photo.id}>
              <CaseAttachmentCard
                caseId={part.caseId}
                attachmentType={null}
                attachments={attachments[photo.id] ? [attachments[photo.id]] : []}
                hasRights={false}
                isMultiple={false}
                isSelectionGroup={false}
                allowOnlyImages={true}
                addWatermark={false}
                showUploadMessage={false}
                downloadModelFile={false}
                viewHiddenServiceDocuments={false}
                organizationName=""
                organizationCity=""
                onAttachmentsChanged={() => undefined}
                headerAction={distanceTypeBadge(photo)}
                isDamagePhoto={true}
              />
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Box>
  </Card>
);

export default DamagePartCard;
